var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "button",
    {
      attrs: {
        color: _vm.color,
        size: _vm.size,
        outlined: _vm.outlined,
        disabled: _vm.disabled || _vm.loading,
        loading: _vm.loading,
        "full-round": _vm.fullRound,
        depressed: _vm.depressed,
        type: _vm.type
      },
      on: {
        click: function($event) {
          _vm.$emit("click")
        }
      }
    },
    [
      _vm.prependIcon
        ? _c("img", {
            attrs: { src: "/static/icons/" + _vm.prependIcon, alt: "ícone" }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm._t("default"),
      _vm._v(" "),
      _vm.loading
        ? _c("v-icon", {
            staticClass: "icon",
            attrs: { name: "circle-notch", scale: _vm.iconScale, spin: "" }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.appendIcon
        ? _c("img", {
            attrs: { src: "/static/icons/" + _vm.appendIcon, alt: "ícone" }
          })
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4a34ce21", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a34ce21","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/_base/Button.vue
// module id = null
// module chunks = 